import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

export default function ToggleButton({
  toggleLabel,
  showFavoritesToggle,
  defaultValue = false,
  ...props
}) {
  const [active, setActive] = useState(defaultValue);

  useEffect(() => {
    // @TODO: Make this a prop to target an input to "sync" state with?
    document.querySelector('#listing_special_listing').value = active;
  }, [active]);

  return (
    // eslint-disable-next-line
    <label className={`custom-filter-toggle ${showFavoritesToggle}`}>
      <span>{active ? 'Active' : 'Inactive'}</span>
      <Toggle
        aria-label="Toggle"
        icons={false}
        className="custom-toggle"
        {...props}
        // defaultChecked={defaultValue}
        checked={active}
        onChange={e => setActive(e.target.checked)}
      />
    </label>
  );
}

ToggleButton.propTypes = {
  defaultValue: PropTypes.bool,
};
